/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import "./index.css";
import React, { useEffect, useState } from "react";
import { View } from "react-native";
import { useViewport } from "@vlinder-web/viewport-provider-react";
import styled from "styled-components";

import background2 from "./assets/img/login-bg.png";

import BeautifulLogin from "./widget/BeautifulLogin";

export interface LoginProps {
    backgroundImg?: string;
    enableSocialLogin?: boolean;
    enableSignup?: boolean;
    apiURL: string;
    termsURL:string;
    onLoginSuccess?(data: any): void;
    [key: string]: any;
}

const LOGIN_BG ="https://i.ibb.co/R4V97JT/login-bg.png"

export const LoginPageVP = (props: LoginProps = {}) => {
    const [isLoading, setIsLoading] = useState(true);
    const { width } = useViewport();
    useEffect(() => {
        let urlSearchParams = new URLSearchParams(window.location.search);
        let params = Object.fromEntries(urlSearchParams.entries());
        if (params?.data) {
            let _data = JSON.parse(params?.data);
            console.log(`url params after parse`, _data);
            if (_data && _data.loginData) {
                props.onLoginSuccess && props.onLoginSuccess(_data);
            }
        }
    }, []);

    useEffect(() => {
        setTimeout(() => {
            setIsLoading(false);
        }, 500);
    }, []);

    return (
        <View>
            <Wrapper backgroundImg={props?.backgroundImg}>
                {isLoading ? (
                    <div
                        style={{
                            height: "100vh",
                            width: "100%",
                            backgroundColor: "rgba(0, 0, 0, 0.1)",
                        }}
                    />
                ) : (
                    <BeautifulLogin {...{ ...props }} />
                )}
            </Wrapper>
        </View>
    );
};

const Wrapper = styled.div`
    align-content: center;
    display: grid;
    height: 100%;
    padding:20px;
    width: 100%;
    justify-content: center;
    position: relative;
    background: radial-gradient(
            218.51% 281.09% at 100% 100%,
            rgba(41, 128, 185, 0.5) 0%,
            rgba(109, 213, 250, 0.3) 45.83%,
            rgba(255, 255, 255, 0.2) 100%
        ),
        url(${(props) =>
            props?.backgroundImg ? props?.backgroundImg : LOGIN_BG});
    background-position: center;
    background-size: cover;
`;
